import { createContext } from 'react';
import { AsyncValidationFormContextState } from './interfaces/async-validation-form';

const defaultState = {
  fields: {},
  isValidating: false,
  setFieldStatus: () => {},
  registerAsyncField: () => {},
  runValidationsAndSubmit: () => {}
};

export const AsyncValidationFormContext =
  createContext<AsyncValidationFormContextState>(defaultState);
